import { render, staticRenderFns } from "./DetailArticles.vue?vue&type=template&id=d4e32a0c&scoped=true"
import script from "./DetailArticles.vue?vue&type=script&lang=js"
export * from "./DetailArticles.vue?vue&type=script&lang=js"
import style0 from "./DetailArticles.vue?vue&type=style&index=0&id=d4e32a0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e32a0c",
  null
  
)

export default component.exports